import React from 'react'
import PortfolioContainer from './components/PortfolioContainer'
import './App.css';
import {send} from 'emailjs-com';
import 'bootstrap/dist/css/bootstrap.min.css';
import Rotate3d from './components/Rotatepics';
import FlipPic from './components/FlipPic'
import "./App.css"
const App = () =>
<PortfolioContainer/>; 

//  <Rotate3d/> 
  

export default App;
